import React from "react";

import { useField, useFormikContext } from "formik";

import PropTypes from "prop-types";

import DatePicker from "../DatePicker";

function FormikDatePicker({ name, ...rest }) {
  const formik = useFormikContext();
  const [field, meta] = useField({ name });

  return (
    <DatePicker
      {...field}
      {...rest}
      error={meta.touched && meta.error}
      touched={meta.touched}
      onChange={(_, date) => {
        formik.setFieldValue(name, date);
      }}
    />
  );
}

FormikDatePicker.propTypes = {
  name: PropTypes.string,
};

export default FormikDatePicker;
